// src/lib/utils/url.ts

/**
 * Adds cache-busting parameters to URLs in development mode
 * @param url - The original URL
 * @returns URL with cache-busting parameter in development, original URL in production
 */
export function withDevCacheBust(url: string): string {
  if (!url) return url
  if (process.env.NODE_ENV !== 'development') return url
  
  // Use a fixed value for development to prevent hydration mismatches
  const cacheBuster = 'dev'
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}nocache=${cacheBuster}`
} 